import { Ref } from 'vue';

import { usePopupStore } from '@/stores/popup';

type imageContainerType = {
	image?: Ref;
	images?: Ref;
	thumbnail?: Ref;
	thumbnails?: Ref;
	maxNum?: number;
};

export default function useSelectImage({ image, images, thumbnail, thumbnails, maxNum = 5 }: imageContainerType) {
	// const store = useStore();
	const popupStore = usePopupStore();

	const MAX_SIZE = 0.5 * 1024 * 1024;

	function getImage(event: Event) {
		const eventTarget = event.target as HTMLInputElement;
		// 파일이 존재하는지
		if (eventTarget?.files && eventTarget?.files[0]) {
			// 이미지일 때만 this.image에 넣음
			if (eventTarget.files[0].type.includes('image') && !eventTarget.files[0].type.includes('gif')) {
				// 2.5MB보다 크면 안받도록
				if (eventTarget.files[0].size > MAX_SIZE) {
					// store.commit('toast/alert', '500KB 이하 이미지를 선택해 주세요.');
					popupStore.openPopup({ content: '500KB 이하 이미지를 선택해주세요.' });
				} else {
					const fileName = eventTarget.files[0].name;
					if (image) {
						image.value = eventTarget.files[0];
					}
					const reader = new FileReader();

					reader.onload = (e) => {
						if (thumbnail) {
							thumbnail.value = { src: e.target?.result, name: fileName };
						}
					};

					reader.readAsDataURL(eventTarget.files[0]);
				}
			} else {
				popupStore.openPopup({ content: '이미지를 선택해주세요.(gif 제외)' });
			}
		}
		eventTarget.value = '';
	}

	function getImages(event: Event) {
		const eventTarget = event.target as HTMLInputElement;
		// 새로 첨부하는 이미지 존재 & 기존에 가지고 있는 이미지 + 새로 첨부하는 이미지의 개수가 5개 이하
		const key = Date.now().toString();
		//추가 이미지의 개수와 새로 업로드하려는 이미지 개수의 합이 5를 넘어가면 동작 막기
		if (images?.value.length + eventTarget?.files?.length > maxNum) {
			// store.commit('toast/alert', '추가이미지는 최대 5장까지 업로드 가능합니다.');
			popupStore.openPopup({ content: `추가이미지는 최대 ${maxNum}장까지 업로드 가능합니다.` });
			return;
		}
		if (
			eventTarget?.files &&
			thumbnails?.value.length + eventTarget?.files.length > 0 &&
			thumbnails?.value.length + eventTarget?.files.length <= maxNum
		) {
			for (let i = 0; i < eventTarget?.files.length; i++) {
				if (eventTarget?.files[i].size > MAX_SIZE) {
					// store.commit('toast/alert', '2.5MB 이하 이미지를 선택해 주세요.');
					popupStore.openPopup({ content: '2MB 이하 이미지를 선택해주세요.' });

					break;
				} else {
					images?.value.push({ src: eventTarget?.files[i], key: key + `/${i}`, name: eventTarget?.files[i].name });
					const fileName = eventTarget?.files[i].name;
					const reader = new FileReader();
					reader.onload = (e) => {
						thumbnails?.value.push({ src: e.target?.result, key: key + `/${i}`, name: fileName });
					};
					reader.readAsDataURL(eventTarget?.files[i]);
				}
			}
		} else if (thumbnails?.value.length + eventTarget?.files?.length > 9) {
			popupStore.openPopup({ content: `추가이미지는 ${maxNum}장 초과 등록할 수 없습니다.` });

			// store.commit('toast/alert', '추가이미지는 5장 초과 등록할 수 없습니다.');
		} else {
			popupStore.openPopup({ content: '이미지를 선택해주세요.(gif 제외)' });
			// store.commit('toast/alert', '이미지를 선택해주세요. (.gif 제외)');
		}
		eventTarget.value = '';
	}
	return {
		getImage,
		getImages,
	};
}
